import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w90 pad15" }
const _hoisted_2 = { class: "fl w30 pad10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "不参加カレンダーを設定", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }, [
  /*#__PURE__*/_createTextVNode(" オーナーが不参加の日程調整で、他の出席者に入力できる可能時間を設定できます。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("不参加カレンダーを設定していない場合、誰からも調整カレンダーを共有されていない状態では、お相手には0件と表示され調整カレンダーを作成してもらいます。 ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "fl w65" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 fw600 mt40" }, "管理用カレンダー", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mt10" }, "通常の日程確定時に登録するイベントとは別に指定カレンダーにイベントを登録できます。", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      (_ctx.showNotAttendAstagSaveButton)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: "pointer centered circle_button skyblueBg fs16",
            style: {"width":"340px","padding":"8px 5px","max-width":"98%"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveAvailableSchedule && _ctx.saveAvailableSchedule(...args)))
          }, _toDisplayString(_ctx.buttonName), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.rm.didConnectCal && _ctx.astag && _ctx.Util.isPresent(_ctx.cm.ctList))
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: _normalizeClass(`rad8 kakugo calendarfirst with_white_bg ofs ${_ctx.isSP ? 'pad20' : 'pad20'}`)
          }, [
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_SelectTag, {
              name: "additonal_connected_calendar",
              id: "additonal_connected_calendar",
              class: "fl fs14 roundForm",
              style: {"min-width":"30px","height":"50px"},
              options: _ctx.selectableCalendars(),
              defaultOption: _ctx.defaultOption(),
              onSelectValue: _ctx.selectCalendar
            }, null, 8, ["options", "defaultOption", "onSelectValue"]),
            _hoisted_9
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _hoisted_10
  ]))
}